import { NgModule } from '@angular/core';
import { DefaultUrlSerializer, Route, UrlSegment, UrlSegmentGroup, UrlSerializer, UrlTree } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { UnAuthorizedInterceptor } from "./helpers";
import { TokenInterceptor } from "./helpers/token.interceptor";
import { LayoutModule } from "./modules/layout/layout.module";
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    // Optional Step: Do some stuff with the url if needed.
    // If you lower it in the optional step 
    // you don't need to use "toLowerCase" 
    // when you pass it down to the next function
    return super.parse(url.toLowerCase());
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    SharedModule,
    AppRoutingModule,
    ToastrModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnAuthorizedInterceptor, multi: true }
    
    //{ provide: UrlSerializer, useClass: LowerCaseUrlSerializer }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function CaseInsensitiveMatcher(url: string) {
  url = url.toLowerCase();

  return function (
    segments: UrlSegment[],
    segmentGroup: UrlSegmentGroup,
    route: Route
  ) {
    let matchSegments = url.split('/');
    if (
      matchSegments.length > segments.length ||
      (matchSegments.length !== segments.length && route.pathMatch === 'full')
    ) {
      return null;
    }

    let consumed: UrlSegment[] = [];
    let posParams: { [name: string]: UrlSegment } = {};
    for (let index = 0; index < segments.length; ++index) {
      if (segments[index] != null || segments[index] != undefined) {
      let segment = segments[index].toString().toLowerCase();
      let matchSegment = matchSegments[index];
      if (matchSegment != undefined) {
        if (matchSegment.startsWith(':')) {
          posParams[matchSegment.slice(1)] = segments[index];
          consumed.push(segments[index]);
        }
        else if (segment === matchSegment) {
          consumed.push(segments[index]);
        }
        else {
          return null;
        }
      }
      }
    }

    return { consumed, posParams };
  }
}
